import React from 'react';
import { Clock } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../ui/alert-dialog';

/**
 * Inactivity Warning Modal - HIPAA compliance session timeout warning
 */
const InactivityWarningModal = ({
  open,
  countdown,
  onContinue,
  onLogout
}) => {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-amber-600">
            <Clock className="h-5 w-5" />
            Session Timeout Warning
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-3">
            <p>For your security, your session will end in <span className="font-bold text-amber-600">{countdown} seconds</span> due to inactivity.</p>
            <p className="text-sm text-gray-500">Are you still there?</p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex gap-2">
          <AlertDialogCancel onClick={onLogout} className="bg-gray-100 hover:bg-gray-200">
            Log Out Now
          </AlertDialogCancel>
          <AlertDialogAction onClick={onContinue} className="bg-teal-600 hover:bg-teal-700">
            Continue Session
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default InactivityWarningModal;
